import { translate, useLocale } from "../localization";
import React, { useEffect } from "react";
import { usePageMetadata } from "../context/PageMetadataContext";
import HomeExperienceRail from "../components/home/HomeExperienceRail";
import "./HomePage.scss";

const HomePage = () => {
  const locale = useLocale();
  const { setTitle, setShowTitleInHeader } = usePageMetadata();

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowTitleInHeader(true);
    setTitle(translate("Dashboard"));
  }, [setShowTitleInHeader, setTitle, locale]);

  return (
    <main className="homePage">
      <HomeExperienceRail />
    </main>
  );
};

export default HomePage;
